import { useQuery } from 'react-query'

import { teamService } from '../service/team-service'

export function useTeamRole(roleId: number) {
  const query = useQuery({
    queryKey: ['team', 'role', roleId],
    queryFn: () => teamService.getTeamRole(roleId),
  })

  return query
}
